// Academy — shared constants + label helpers (mirror backend enums).
export const CATEGORIES = [
  { value: "flagship",            label: "Flagship" },
  { value: "bundle",              label: "Career Course Bundle" },
  { value: "finance_markets",     label: "Finance, Investment & Stock-Market" },
  { value: "it",                  label: "IT Programs" },
  { value: "non_it",              label: "Non-IT Programs" },
  { value: "ielts",               label: "IELTS" },
  { value: "pte",                 label: "PTE" },
  { value: "toefl",               label: "TOEFL" },
  { value: "celpip",              label: "CELPIP" },
  { value: "duolingo",            label: "Duolingo" },
  { value: "gre",                 label: "GRE" },
  { value: "gmat",                label: "GMAT" },
  { value: "csat",                label: "CSAT" },
  { value: "spoken_english",      label: "Spoken English" },
  { value: "german",              label: "German" },
  { value: "french",              label: "French" },
  { value: "career_development",  label: "Career Development" },
  { value: "corporate_training",  label: "Corporate Training" },
  { value: "indian_admissions",   label: "Indian Admissions" },
  { value: "online_degrees",      label: "Online Degrees" },
];

export const CLASSIFICATIONS = [
  { value: "miro_in_house",       label: "MIRO In-House",
    tone: { bg: "#DBEAFE", fg: "#1D4ED8" } },
  { value: "partner_delivered",   label: "Partner-Delivered",
    tone: { bg: "#EDE9FE", fg: "#6D28D9" } },
  { value: "admission_service",   label: "Admission Service",
    tone: { bg: "#FEF3C7", fg: "#B45309" } },
  { value: "test_preparation",    label: "Test Preparation",
    tone: { bg: "#E0F2FE", fg: "#0369A1" } },
  { value: "language_program",    label: "Language Program",
    tone: { bg: "#FCE7F3", fg: "#BE185D" } },
  { value: "corporate_training",  label: "Corporate Training",
    tone: { bg: "#DCFCE7", fg: "#15803D" } },
];

export const DELIVERY_MODES = [
  { value: "online",             label: "Online" },
  { value: "offline",            label: "Offline" },
  { value: "hybrid",             label: "Hybrid" },
  { value: "blended",            label: "Blended" },
  { value: "online_or_blended",  label: "Online / Blended" },
];

export const WORKFLOW_STATUSES = [
  { value: "draft",            label: "Draft",             tone: { bg: "#F1F5F9", fg: "#475569" } },
  { value: "pending_approval", label: "Pending approval",  tone: { bg: "#FEF3C7", fg: "#B45309" } },
  { value: "approved",         label: "Approved",          tone: { bg: "#DCFCE7", fg: "#15803D" } },
  { value: "active",           label: "Active",            tone: { bg: "#DBEAFE", fg: "#1D4ED8" } },
  { value: "inactive",         label: "Inactive",          tone: { bg: "#E5E7EB", fg: "#374151" } },
  { value: "archived",         label: "Archived",          tone: { bg: "#FEE2E2", fg: "#B91C1C" } },
];

export const DURATION_UNITS = [
  { value: "weeks",  label: "weeks" },
  { value: "months", label: "months" },
  { value: "days",   label: "days" },
  { value: "hours",  label: "hours" },
];

export const PROGRAM_STATUSES = [
  { value: "active",   label: "Active",
    tone: { bg: "#DCFCE7", fg: "#15803D" } },
  { value: "inactive", label: "Inactive",
    tone: { bg: "#F1F5F9", fg: "#475569" } },
  { value: "draft",    label: "Draft",
    tone: { bg: "#FEF3C7", fg: "#B45309" } },
];

export const BATCH_STATUSES = [
  { value: "planned",   label: "Planned",   tone: { bg: "#F1F5F9", fg: "#475569" } },
  { value: "open",      label: "Open",      tone: { bg: "#E0F2FE", fg: "#0369A1" } },
  { value: "full",      label: "Full",      tone: { bg: "#FEF3C7", fg: "#B45309" } },
  { value: "ongoing",   label: "Ongoing",   tone: { bg: "#DBEAFE", fg: "#1D4ED8" } },
  { value: "completed", label: "Completed", tone: { bg: "#E0E7FF", fg: "#4338CA" } },
  { value: "cancelled", label: "Cancelled", tone: { bg: "#FEE2E2", fg: "#B91C1C" } },
];

export const ENROLMENT_STATUSES = [
  { value: "enrolled",    label: "Enrolled",    tone: { bg: "#DBEAFE", fg: "#1D4ED8" } },
  { value: "in_progress", label: "In progress", tone: { bg: "#FEF3C7", fg: "#B45309" } },
  { value: "completed",   label: "Completed",   tone: { bg: "#E0E7FF", fg: "#4338CA" } },
  { value: "on_hold",     label: "On hold",     tone: { bg: "#F1F5F9", fg: "#475569" } },
  { value: "dropped",     label: "Dropped",     tone: { bg: "#FEE2E2", fg: "#B91C1C" } },
];

export const PAYMENT_STATUSES = [
  { value: "not_started", label: "Not started",tone: { bg: "#F1F5F9", fg: "#475569" } },
  { value: "partial",     label: "Partial",    tone: { bg: "#FEF3C7", fg: "#B45309" } },
  { value: "paid",        label: "Paid",       tone: { bg: "#DCFCE7", fg: "#15803D" } },
  { value: "overdue",     label: "Overdue",    tone: { bg: "#FEE2E2", fg: "#B91C1C" } },
  { value: "refunded",    label: "Refunded",   tone: { bg: "#EDE9FE", fg: "#6D28D9" } },
];

export const PAYMENT_PLANS = [
  { value: "one_time",           label: "One-time" },
  { value: "two_installments",   label: "2 Installments" },
  { value: "three_installments", label: "3 Installments" },
  { value: "monthly_emi",        label: "Monthly EMI" },
  { value: "custom",             label: "Custom" },
];

export const INTERNSHIP_STAGES = [
  { value: "not_applicable", label: "N/A" },
  { value: "not_started",    label: "Not started" },
  { value: "sourcing",       label: "Sourcing" },
  { value: "applied",        label: "Applied" },
  { value: "interview",      label: "Interview" },
  { value: "offered",        label: "Offered" },
  { value: "active",         label: "Active" },
  { value: "completed",      label: "Completed" },
];

export const CAREER_SUPPORT_STAGES = [
  { value: "not_started",     label: "Not started" },
  { value: "resume_prep",     label: "Resume prep" },
  { value: "mock_interviews", label: "Mock interviews" },
  { value: "referrals",       label: "Referrals" },
  { value: "active_search",   label: "Active search" },
  { value: "placed",          label: "Placed" },
  { value: "not_seeking",     label: "Not seeking" },
];

export const CERTIFICATE_STATUSES = [
  { value: "not_issued", label: "Not issued" },
  { value: "pending",    label: "Pending" },
  { value: "issued",     label: "Issued" },
];

export const findLabel = (arr, v) => arr.find(x => x.value === v)?.label || v;
export const findTone  = (arr, v) => arr.find(x => x.value === v)?.tone;

export const formatDuration = (p) => {
  if (!p) return "—";
  const unit = (p.duration_unit || "weeks").replace(/s$/, "");
  return `${p.duration_value || 0} ${unit}${(p.duration_value || 0) === 1 ? "" : "s"}`;
};

export const formatMoney = (v) =>
  v == null ? "—" : `₹${Number(v).toLocaleString("en-IN")}`;
